import { render, staticRenderFns } from "./QuizQuestionDesktopHeader.vue?vue&type=template&id=71abd3ea&scoped=true&"
import script from "./QuizQuestionDesktopHeader.vue?vue&type=script&lang=js&"
export * from "./QuizQuestionDesktopHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuizQuestionDesktopHeader.vue?vue&type=style&index=0&id=71abd3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71abd3ea",
  null
  
)

export default component.exports